import { createContext } from "react";
import useAuth from "../hooks/useAuth";

const Context = createContext();

function UserProvider({ children }) {
    const { authenticated, currentUser, register, logout, login } = useAuth();

    return (
        <Context.Provider value={{ authenticated, currentUser, register, logout, login }}>
            {children}
        </Context.Provider>
    );
}

export { Context, UserProvider };